import React from 'react'
import { MapBullet, MapBullets } from '~/components/molecules/Maps/MapBullets'
import * as S from './styled'
import { OptimizedImage } from '~/components/molecules/OptimizedImage'

export const MapAndBullets: React.FC<{
  bullets: MapBullet[]
  mapSrc: string
}> = ({ bullets, mapSrc }) => (
  <div>
    <S.MapWrapper>
      <OptimizedImage src={mapSrc} width={680} height={442} />
    </S.MapWrapper>
    <MapBullets bullets={bullets} />
  </div>
)
